import { useReducer } from 'react';
import { IFrameworkPCState, initFrameworkState } from '../types';

const reducer = (state: IFrameworkPCState, { payload }: { payload: any }) => {
  return {
    ...state,
    ...payload
  }
}

const useRedux: () => [IFrameworkPCState, any] = () => {
  const [state, dispatch] = useReducer(reducer, initFrameworkState);
  return [
    state,
    dispatch
  ]
}

export default useRedux;
